import { addDays, isBefore, isSameDay } from 'date-fns';
import type { Factory } from 'walden-fast/types/mocks';
import type { OffsetDetailData } from 'walden-fast/types/offsets';

const MOCK_EMISSION_DETAIL: OffsetDetailData = {
  day: new Date(1732721945000),
  tonnesCo2: 200,
};

export const offsetDetailFactory: Factory<OffsetDetailData> = (overrides) => ({
  ...MOCK_EMISSION_DETAIL,
  id: Math.floor(Math.random() * 100).toString(),
  ...overrides,
});

export const offsetDetailsFrom = (startDate: Date) => {
  const result: OffsetDetailData[] = [];
  let currentDate = new Date(startDate);
  const today = new Date();

  const startValue = Math.floor(Math.random() * PSEUDO_RANDOM_VALUES.length);

  while (isBefore(currentDate, today) || isSameDay(currentDate, today)) {
    const nextIndex =
      (startValue + (result.length - 1)) % PSEUDO_RANDOM_VALUES.length;
    const randomValue =
      (PSEUDO_RANDOM_VALUES[nextIndex] as number) +
      Math.floor(Math.random() * 5 - 2);

    result.push(
      offsetDetailFactory({
        tonnesCo2: Math.max(0, randomValue),
        day: new Date(currentDate),
      }),
    );
    currentDate = addDays(currentDate, 1);
  }

  return result;
};

const PSEUDO_RANDOM_VALUES = [
  10, 11, 13, 14, 12, 11, 10, 9, 9, 8, 7, 7, 5, 4, 4, 4, 6, 6, 6, 6, 6, 6, 7, 6,
  8, 9, 7, 8, 8, 8, 6, 6, 7, 9, 7, 7, 9, 10, 11, 11, 10, 11, 10, 12, 11, 9, 10,
  12, 13, 11, 9, 9, 9, 8, 6, 8, 9, 11, 13, 12, 14, 15, 13, 14, 12, 14, 15, 17,
  19, 20, 19, 20, 22, 23, 25, 27, 26, 25, 23, 24, 25, 23, 23, 24, 26, 26, 26,
  28, 30, 29, 29, 29, 31, 33, 35, 35, 35, 35, 36, 34,
];
